import defaultErrorHandler from "api/global/default-error-handler";
import {
    getScheduleSummary,
    getServiceReassignment,
    setServiceReassignment,
    getMerchandiserDashboardNotifications,
    getMerchandiserDashboardConfirmedServices,
} from "api/menu/dashboard/requests";

export const DASHBOARD_SCHEDULE_SUMMARY_GET = "DASHBOARD_SCHEDULE_SUMMARY_GET";
export const DASHBOARD_SERVICE_REASSIGNMENT_GET = "DASHBOARD_SERVICE_REASSIGNMENT_GET";
export const MERCHANDISER_DASHBOARD_NOTIFICATIONS_GET = "MERCHANDISER_DASHBOARD_NOTIFICATIONS_GET";
export const MERCHANDISER_DASHBOARD_SERVICES_GET = "MERCHANDISER_DASHBOARD_SERVICES_GET";

export const fetchScheduleSummary = () => dispatch => {
    getScheduleSummary()
        .then(response => {
            dispatch({
                type: DASHBOARD_SCHEDULE_SUMMARY_GET,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const fetchServiceReassignment = (fromDate = null, toDate = null) => dispatch => {
    getServiceReassignment(fromDate, toDate)
        .then(response => {
            dispatch({
                type: DASHBOARD_SERVICE_REASSIGNMENT_GET,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const actServiceReassignment = (id, callback) => dispatch => {
    setServiceReassignment(id)
        .then(callback)
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const fetchMerchandiserDashboardNotifications = () => dispatch => {
    getMerchandiserDashboardNotifications()
        .then(response => {
            dispatch({
                type: MERCHANDISER_DASHBOARD_NOTIFICATIONS_GET,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const fetchMerchandiserDashboardConfirmedServices = (fromDate, toDate, callback) => dispatch => {
    getMerchandiserDashboardConfirmedServices(fromDate, toDate)
        .then(response => {
            dispatch({
                type: MERCHANDISER_DASHBOARD_SERVICES_GET,
                payload: response.data
            });
            callback(true);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};
